import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  HttpService,
  NotificationService,
  PurchaseContractLineSelect,
  PurchaseOrderFromPreviousIds,
  PurchaseOrderLineQuickCreate,
  TmsWebBaseEditCreateService,
} from 'tms-lib';
import {
  PurchaseContractForOrder,
  PurchaseContractLine,
  PurchaseContractLineDetails,
  PurchaseContractLineForCreate,
  PurchaseContractLineHeader,
  PurchaseContractLineQuickCreate,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PurchaseContractLineService extends TmsWebBaseEditCreateService<
  PurchaseContractLine,
  PurchaseContractLineDetails
> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('PurchaseContractLine', $localize`Purchase Contract Line`, httpService, notificationService);
  }

  getForPurchaseContractHeader(id: string): Observable<PurchaseContractLineHeader[]> {
    return this.httpService.get<PurchaseContractLineHeader[]>(`${this.apiUrl}/PurchaseContractHeader?id=${id}`);
  }

  quickCreate(PurchaseContractLineQuickCreate: PurchaseContractLineQuickCreate): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/QuickCreate`, PurchaseContractLineQuickCreate);
  }

  getSelectItems(supplierId: string, productId: string): Observable<PurchaseContractLineSelect[]> {
    return this.httpService.get<PurchaseContractLineSelect[]>(
      `${this.apiUrl}/GetSelectItems?supplierId=${supplierId}&productId=${productId}`,
    );
  }

  getForPurchaseOrder(id: string): Observable<PurchaseContractForOrder> {
    return this.httpService.get<PurchaseContractForOrder>(`${this.apiUrl}/GetForPurchaseOrder?id=${id}`);
  }

  getOutstandingContracts(productId: string): Observable<PurchaseContractLineForCreate[]> {
    return this.httpService.get<PurchaseContractLineForCreate[]>(
      `${this.apiUrl}/GetOutstandingContracts?productId=${productId}`,
    );
  }

  getFromContract(supplierId: string, search: string): Observable<PurchaseContractLine[]> {
    return this.httpService.get<PurchaseContractLine[]>(
      `${this.apiUrl}/GetFromContract?supplierId=${supplierId}&search=${search}`,
    );
  }

  createFromContract(
    purchaseOrderHeaderId: string,
    ids: PurchaseOrderFromPreviousIds[],
  ): Observable<PurchaseOrderLineQuickCreate> {
    return this.httpService.post<PurchaseOrderLineQuickCreate>(`${this.apiUrl}/CreateFromContract`, {
      purchaseOrderHeaderId,
      ids,
    });
  }
}
